import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Navbar from '../../Shared/Navbar/Navbar';
import ProductCards from './ProductCards/ProductCards';
import Ginkolet from '../../../resources/images/Ginkolet.svg';
import Siplin from '../../../resources/images/Siplin.svg';
import Biotil from '../../../resources/images/Biotil.svg';
import Biosina from '../../../resources/images/Biosina.svg';
import Biovina from '../../../resources/images/Biovina.svg';
import Bioga from '../../../resources/images/Bioga.svg';
import Panexgine from '../../../resources/images/Panexgine.svg';
import './Products.css';
import { Helmet } from 'react-helmet';

const productsData = [{
    name: 'Ginkolet',
    details: 'Cerebral And Peripheral Vasotherapeutic',
    banglaDetails: "সেরিবেরাল এবং পেরিফেরাল ভাসোথেরাপিউটিক",
    img: Ginkolet,
    genericName: 'Ginkgo Biloba',
    id: 1
},
{
    name: 'Panexgine',
    details: 'Nervous weakness, Sexual weakness, Weakness of memory, Alcohol side effects, Virus infection',
    banglaDetails: "স্নায়বিক দুর্বলতা, যৌন দুর্বলতা, স্মৃতির দুর্বলতা, অ্যালকোহলের পার্শ্ব প্রতিক্রিয়া, ভাইরাস সংক্রমণ",
    img: Panexgine,
    genericName: 'Panax Gingseng',
    id: 2
},
{
    name: 'Siplin',
    details: 'Protein, Vitamins And General Nutrients',
    banglaDetails: "প্রোটিন, ভিটামিন এবং সাধারণ পুষ্টি উপাদান",
    img: Siplin,
    genericName: 'Spirulina',
    id: 3
},
{
    name: 'Biotil',
    details: 'The Millennium Brain Booster And Antioxidants',
    banglaDetails: "মিলেনিয়াম ব্রেন বুস্টার এবং অ্যান্টিঅক্সিড্যান্ট",
    img: Biotil,
    genericName: 'Brahmi Rasayan',
    id: 4
},
{
    name: 'Biosina',
    details: 'Liver Protective And Improve Digestive System',
    banglaDetails: "লিভার প্রতিরক্ষাকারক এবং হজম শক্তি বৃদ্ধি করে",
    img: Biosina,
    genericName: 'Nabayas Louha',
    id: 5
},
{
    name: 'Biovina',
    details: 'Strength, Nutritious, Heart, Digestive',
    banglaDetails: "শক্তিবর্ধক, পুষ্টিকারক, হৃতশক্তি বর্ধক, হজমিকারক",
    img: Biovina,
    genericName: 'Chandanasav',
    id: 6
},
{
    name: 'Bioga',
    details: 'Sexual enhancer, Rati Is The Sustainability Editor Of Orgasm',
    banglaDetails: "যৌন বর্ধক",
    img: Bioga,
    genericName: 'Rati Bilas',
    id: 7
}
]

const Products = () => {
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Products | Biotech</title>
                <meta name="keywords" content="Biotech Products, biotech, biotech pharma, biotech pharmaceuticals, biotech pharmaceutical, biotech ay, biotech (ay), biotech pharma (ay), biotech pharmaceutical (ay), biotech pharmaceuticals (ay)"/>
            </Helmet>
                <Navbar isHome={false} />
                <div className="container">
                    <div className="row"> {
                        productsData.map(product => < ProductCards product={product} key={product.name} />)
                    }
                    </div>
                </div>
                <Footer />
        </div>
    );
};

export default Products;
